import React from 'react';
import moment from 'moment-timezone';
import CountdownTimer from './CountdownTimer';
const Fixtures = ({ match, selectedCompetition, matchTimeGMT }) => {
    const imageURL = process.env.REACT_APP_IMAGE_URL;
    const defaultPlayerImage = `${imageURL}player-thumb.jpg`;
    const defaultTeamImage = `${imageURL}default-team-logo.png`;
    const handleImageError = (e) => {
        e.target.src = defaultPlayerImage;
    };
    const handleTeamImageError = (e) => {
        e.target.src = defaultTeamImage;
    };

    const formatMatchTime = () => {
        if (!match.GMTMatchDate && !match.GMTMatchTime && match.MatchDate) {
            // If GMT values are null but MatchDate exists, show only MatchDate
            return moment(match.MatchDate).format('DD MMM YYYY');
        }

        // Original GMT to IST conversion logic
        const matchDate = match.GMTMatchDate;
        const matchTimeGMT = match.GMTMatchTime;

        if (!matchDate || !matchTimeGMT) {
            return match.MatchDate ? moment(match.MatchDate).format('DD MMM YYYY') : '';
        }

        const gmtTime = moment.utc(`${matchDate} ${matchTimeGMT}`, "YYYY-MM-DD HH:mm");
        const istTime = gmtTime.clone().tz('Asia/Kolkata');
        return `${istTime.format('DD MMM YYYY hh:mm A')} IST`;
    };

    // Function to generate calendar URLs
    const getCalendarUrls = () => {
        const startDate = match.GMTMatchDate && match.GMTMatchTime
            ? moment.utc(`${match.GMTMatchDate} ${match.GMTMatchTime}`, "YYYY-MM-DD HH:mm")
            : moment(match.MatchDate);
        // Convert to IST
        const istStartDate = startDate.clone().tz('Asia/Kolkata');
        // Set end date to 9 hours after start (typical cricket match duration)
        const istEndDate = istStartDate.clone().add(9, 'hours');

        // Format dates for calendar URLs
        const startDateStr = istStartDate.format('DD MMM YYYY HH:mm').replace(/ /g, '%20');
        const endDateStr = istEndDate.format('DD MMM YYYY HH:mm').replace(/ /g, '%20');

        // Base parameters
        const baseParams = new URLSearchParams({

            'utz': '330', // IST timezone offset
            'uln': 'en-US',
            'vjs': '1.5',
            'e[0][timezone]': 'Asia/Kolkata',
            'e[0][title]': `${match.HomeTeamName || match.FirstBattingTeamName} vs ${match.AwayTeamName || match.SecondBattingTeamName}`,
            'e[0][description]': match.GroundName || '',
            'e[0][location]': match.city || '',
            'e[0][organizer]': '',
            'e[0][organizer_email]': '',
            'e[0][date_start]': startDateStr,
            'e[0][date_end]': endDateStr

        }).toString();



        return {
            ical: `https://addtocalendar.com/atc/ical?${baseParams}`,
            google: `https://addtocalendar.com/atc/google?${baseParams}`,
            outlook: `https://addtocalendar.com/atc/outlook?${baseParams}`,
            outlookOnline: `https://addtocalendar.com/atc/outlookonline?${baseParams}`,
            yahoo: `https://addtocalendar.com/atc/yahoo?${baseParams}`
        };

    };

    const calendarUrls = getCalendarUrls();
    return (
        <div className="matchBox fixtureStrip uniform-grid">
            <div className="matchBox__left sm-flex sm-align-center">
                <div className="matchTeams sm-flex sm-align-center">
                    <div className="tLogo">
                        <img alt={match.HomeTeamName} onError={handleTeamImageError}
                            src={match.MatchHomeTeamLogo || match.HomeTeamLogo || defaultTeamImage} />
                    </div>
                    <div className="teamNames ">{match.HomeTeamName}</div>

                </div>
                <div className="tVs">vs </div>
                <div className="matchTeams sm-flex sm-align-center">
                    <div className="tLogo">
                        <img alt={match.AwayTeamName} onError={handleTeamImageError}
                            src={match.MatchAwayTeamLogo || match.AwayTeamLogo || defaultTeamImage} />
                    </div>
                    <div className="teamNames " >{match.AwayTeamName}</div>
                </div>
            </div>
            <div className="matchBox__right sm-flex sm-align-center">
                <div className="match-tournament-name">
                    {match.CompetitionName ||
                        (selectedCompetition?.CompetitionID === match.CompetitionID && selectedCompetition?.CompetitionName)}
                </div>
                <div className="matchInfom sm-flex">
                    <div className="matchInfom_left">
                        <div className="match-order">
                            <span className="ng-binding"></span>
                            <span>{formatMatchTime()} </span>                        </div>
                        <div className="match-ground-name">
                            <span className="matGround">{match.GroundName}</span>
                            {match.city && match.GroundName && <span>,&nbsp;</span>}
                            {match.city && <span className="matPlace">{match.city}</span>}
                        </div>
                    </div>
                    <div className="matchInfom_right">
                        {match.Comments && (
                            <div className="matchResult">{match.Comments}</div>
                        )}

                        <CountdownTimer
                            matchDate={match.GMTMatchDate}
                            matchTimeGMT={match.GMTMatchTime}
                        />
                        <ul className="otherMatchInfo">
                            <li>
                                <span className="addtocalendar atc-style-icon atc-style-menu-wb">
                                    <a className="atcb-link" tabIndex="1">
                                        <img
                                            src="https://instaplay-cricketcloud-live.s3-ap-southeast-1.amazonaws.com/matchcentrev3/addtocalendar/cal-blue.png"
                                            alt="calendar"
                                        />
                                    </a>

                                    <ul className="atcb-list">
                                        <li className="atcb-item">
                                            <a className="atcb-item-link" href={calendarUrls.ical} target="_blank" rel="nofollow">iCalendar</a>
                                        </li>
                                        <li className="atcb-item">
                                            <a className="atcb-item-link" href={calendarUrls.google} target="_blank" rel="nofollow">Google Calendar</a>
                                        </li>
                                        <li className="atcb-item">
                                            <a className="atcb-item-link" href={calendarUrls.outlook} target="_blank" rel="nofollow">Outlook</a>
                                        </li>
                                        <li className="atcb-item">
                                            <a className="atcb-item-link" href={calendarUrls.outlookOnline} target="_blank" rel="nofollow">Outlook Online</a>
                                        </li>
                                        <li className="atcb-item">
                                            <a className="atcb-item-link" href={calendarUrls.yahoo} target="_blank" rel="nofollow">Yahoo! Calendar</a>
                                        </li>
                                    </ul>
                                </span>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default Fixtures;